import * as RadioGroup from '@radix-ui/react-radio-group';
import cn from 'classnames';
import React from 'react';

import {getLocalizedStrings} from '../../../../services/localization/localizationService';

const EmotionRadioGroup = ({ariaLabel, emotionRadioTypesList, onRadioChange, selectedType}) => {
    const localizedStrings = getLocalizedStrings();

    return (
        <RadioGroup.Root
            onValueChange={onRadioChange}
            className='my-4 flex h-24 w-full gap-2 rtl:flex-row-reverse'
            aria-label={ariaLabel}
            required
        >
            {emotionRadioTypesList.map(({type, title, icon: Icon}) => (
                <RadioGroup.Item
                    className={cn(
                        'flex h-full w-full cursor-pointer flex-col items-center justify-center rounded-[16px] border-2 border-border',
                        {'border-transparent bg-tertiary': selectedType === type}
                    )}
                    key={type}
                    value={type}
                    id={type}
                >
                    <Icon className={selectedType === type ? '' : 'fill-border'} />
                    <span className={cn('pt-2 text-12 text-border', {'text-primary': selectedType === type})}>
                        {localizedStrings[title]}
                    </span>
                </RadioGroup.Item>
            ))}
        </RadioGroup.Root>
    );
};

export default EmotionRadioGroup;
